import { createContext, useContext } from "react";

export const EntryPointContext = createContext();

export const useEntryPointContext = () => {
  return useContext(EntryPointContext);
};

